<template>
  <VMain
    id="main-content"
    tabindex="-1"
    class="layout-default h-100"
  >
    <slot />
  </VMain>
</template>
